import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"
import { Duration } from "effect"

export const appConfig: AppConfig<"the-struts"> = {
  appId: "the-struts",
  cookiePrefix: "ts",
  lang: "EN",
  artist: {
    name: "The Struts"
  },
  meta: {
    description: "The Struts"
  },
  emailSender: {
    name: "The Struts",
    email: "thestruts@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/${appConfig.appId}`
      }
    },
    get files() {
      return {
        exclusives: `${appConfig.appId}/exclusives`,
        fanClips: `${appConfig.appId}/fan-clips`,
        merchSkus: `${appConfig.appId}/merch-skus`,
        playlistCoverImages: `${appConfig.appId}/playlist-cover-images`,
        showImages: `${appConfig.appId}/show-images`,
        showCheckInRequestImages: `${appConfig.appId}/check-in-request-images`
      }
    },
    get music() {
      return {
        trackAudios: `${appConfig.appId}/track-audios`,
        playlistDownloadFiles: `${appConfig.appId}/playlist-download-files`
      }
    }
  },
  merch: {
    initialOwnerId: "f4513e00-bb5f-4623-ac4b-9c5e06c45bf5",
    initialOwnerAddress: "0x460cd9178000f0e087e2c1a847058c3ffed64290"
  },
  tasks: {
    exclusiveLinkDelay: Duration.hours(0)
  },
  checkIn: {
    hidePrompt: false
  },
  shopUrl: null,
  socialLinks: [
    {
      platform: SocialPlatform.Website,
      label: "Website",
      href: "https://www.thestruts.com"
    },
    {
      platform: SocialPlatform.Instagram,
      label: "Instagram",
      href: "https://instagram.com/thestruts"
    },
    {
      platform: SocialPlatform.Twitter,
      label: "X",
      href: "https://x.com/thestruts"
    },
    {
      platform: SocialPlatform.Spotify,
      label: "Spotify",
      href: "https://open.spotify.com/artist/3lDpdwM8KILepMHqBWUhIA?si=mJjO2qbCR7y6hVNO4K1Xcg"
    },
    {
      platform: SocialPlatform.Youtube,
      label: "YouTube",
      href: "https://www.youtube.com/user/strutsofficial"
    }
  ],
  joinProof: null,
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og.png`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/logo.webp`,
          width: 60
        },
        background: `${appConfig.s3.assets.appUrl}/profile-background.webp`,
        howToTap: null,
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/email-logo.png`,
            width: 60
          }
        },
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.vfUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: null,
        howToTap: null
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: null,
        artistTermsOfService: null,
        sweepstakeRules: null
      }
    }
  }
}
